// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 登录接口 POST /web/account/login */
export async function login(
  body: API.WebPcUserLoginDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.LoginVO>>('/web/account/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 退出登录接口 POST /web/account/logout */
export async function logout(options?: { [key: string]: any }) {
  return request<API.ApiResponse<null>>('/web/account/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 发送短信验证码 POST /web/account/sendSmsCode */
export async function sendSmsCode(
  body: API.SendSmsCodeDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/account/sendSmsCode', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 注册 POST /web/account/register */
export async function register(
  body: API.WebPcUserRegisterDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/account/register', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 查询个人资料 GET /web/account/profile */
export async function queryAccountProfile(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.WebPcUserProfileVO>>('/web/account/profile', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 已绑定设备（含额度到期推算） GET /web/account/bound-devices */
export async function queryBoundDevices(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.BoundDeviceQuotaVO[]>>(
    '/web/account/bound-devices',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 云端已绑定摄像头（含路数权益到期推算） GET /web/account/bound-cloud-devices */
export async function queryBoundCloudDevices(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.BoundDeviceQuotaVO[]>>(
    '/web/account/bound-cloud-devices',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 修改用户信息 PUT /web/account/profile */
export async function updateProfile(
  body: API.WebPcUserProfileUpdateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.WebPcUserProfileVO>>('/web/account/profile', {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

/** 修改密码 PUT /web/account/password */
export async function changePassword(
  body: API.WebPcUserChangePasswordDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/account/password', {
    method: 'PUT',
    data: body,
    ...(options || {}),
  });
}

/** 解绑摄像头 DELETE /web/account/camera/{videoSourceId} */
export async function unbindCamera(
  videoSourceId: string | number,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>(`/web/account/camera/${videoSourceId}`, {
    method: 'DELETE',
    ...(options || {}),
  });
}

/** 分页查询算法列表 POST /api/web/algorithm/page */
export async function getAlgorithmPage(
  body: API.AlgorithmPageRequest,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.AlgorithmPageResponse>>(
    '/web/algorithm/page',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 生成支付二维码 POST /web/order/pay/qr */
export async function createPayQr(
  body: API.AlgorithmPayQrCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>('/web/order/pay/qr', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 查询支付状态 POST /web/order/pay/status */
export async function getPayStatus(
  body: API.PayStatusQueryDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayStatusVO>>('/web/order/pay/status', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 免费算法激活 POST /web/order/pay/free-activate */
export async function freeActivateAlgorithm(
  body: { algorithmId: number },
  options?: { [key: string]: any },
) {
  return request<
    API.ApiResponse<{
      userAlgorithmId: number;
      algorithmId: number;
      activatedTime: string;
    }>
  >('/web/order/pay/free-activate', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 可购买设备额度套餐 GET /web/device/quota/list */
export async function listDeviceQuotaPackages(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.DeviceQuotaPackageVO[]>>(
    '/web/device/quota/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 可购买云端算力套餐 GET /web/cloud/quota-package/list */
export async function listCloudQuotaPackages(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.CloudQuotaPackageVO[]>>(
    '/web/cloud/quota-package/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 设备额度购买二维码 POST /web/order/pay/device-quota/qr */
export async function createDeviceQuotaPayQr(
  body: API.DeviceQuotaPayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>(
    '/web/order/pay/device-quota/qr',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 云端算力套餐购买二维码 POST /web/order/pay/cloud-quota-package/qr */
export async function createCloudQuotaPackagePayQr(
  body: API.CloudQuotaPackagePayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>(
    '/web/order/pay/cloud-quota-package/qr',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 训练时长购买二维码 POST /web/order/pay/train-quota/qr */
export async function createTrainQuotaPayQr(
  body: { hours: number; paymentMethod?: string },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>(
    '/web/order/pay/train-quota/qr',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 获取我的算法列表 GET /web/my-algorithm/list */
export async function getMyAlgorithmList(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.WebMyAlgorithmVO[]>>(
    '/web/my-algorithm/list',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 确认推送分组 POST /web/my-algorithm/push-groups（云端计费 V2） */
export async function setAlgorithmPushGroups(
  body: API.WebAlgorithmGroupBindDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/my-algorithm/push-groups', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 获取算法预警配置 GET /web/my-algorithm/warning-config/{userAlgorithmId} */
export async function getAlgorithmWarningConfig(
  userAlgorithmId: number,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.WebAlgorithmWarningVO>>(
    `/web/my-algorithm/warning-config/${userAlgorithmId}`,
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 保存算法预警配置 PUT /web/my-algorithm/warning-config */
export async function saveAlgorithmWarningConfig(
  body: API.WebAlgorithmWarningSaveDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/my-algorithm/warning-config', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 云端算力概览 GET /web/my-compute/cloud/summary */
export async function getMyComputeCloudSummary(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.MyComputeCloudSummaryVO | null>>(
    '/web/my-compute/cloud/summary',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 本地算力概览 GET /web/my-compute/local/summary */
export async function getMyComputeLocalSummary(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.MyComputeLocalSummaryVO | null>>(
    '/web/my-compute/local/summary',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}

/** 算力订阅记录分页 POST /web/my-compute/orders/page */
export async function pageMyComputeOrders(
  body: API.MyComputeOrderPageRequest,
  options?: { [key: string]: any },
) {
  return request<
    API.ApiResponse<{
      records: API.MyComputeOrderVO[];
      total: number;
      current: number;
      size: number;
    }>
  >('/web/my-compute/orders/page', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

// ===== 云端计费 V2 =====

/** 工作台 / 计费概览 GET /web/cloud/billing/overview */
export async function getCloudBillingOverview(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.CloudBillingOverviewVO>>(
    '/web/cloud/billing/overview',
    { method: 'GET', ...(options || {}) },
  );
}

/** 我的云端套餐 GET /web/cloud/billing/my-package */
export async function getCloudMyPackage(options?: { [key: string]: any }) {
  return request<API.ApiResponse<API.CloudMyPackageVO>>(
    '/web/cloud/billing/my-package',
    { method: 'GET', ...(options || {}) },
  );
}

/** 超额计费模式切换 POST /web/cloud/billing/excess-mode */
export async function switchCloudExcessMode(
  body: API.ExcessModeSwitchDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<null>>('/web/cloud/billing/excess-mode', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 存储商品列表 GET /web/cloud/storage-product/list */
export async function listCloudStorageProducts(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.StorageProductListVO>>(
    '/web/cloud/storage-product/list',
    { method: 'GET', ...(options || {}) },
  );
}

/** 管道+存储试算 POST /web/cloud/billing/quote */
export async function quoteCloudBilling(
  body: API.CloudBillingQuoteDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.CloudBillingQuoteVO>>(
    '/web/cloud/billing/quote',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 管道+存储扫码支付 POST /web/order/pay/cloud-pipe/qr */
export async function createCloudPipePayQr(
  body: API.CloudPipePayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>('/web/order/pay/cloud-pipe/qr', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 管道+存储余额支付 POST /web/order/pay/cloud-pipe/balance */
export async function payCloudPipeByBalance(
  body: API.CloudPipePayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayStatusVO | null>>(
    '/web/order/pay/cloud-pipe/balance',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 存储增购试算 POST /web/cloud/billing/storage/quote */
export async function quoteCloudStorage(
  body: API.StorageQuoteDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.StorageQuoteVO>>(
    '/web/cloud/billing/storage/quote',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 存储扫码支付 POST /web/order/pay/storage/qr */
export async function createStoragePayQr(
  body: API.StoragePayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>('/web/order/pay/storage/qr', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: body,
    ...(options || {}),
  });
}

/** 存储余额支付 POST /web/order/pay/storage/balance */
export async function payStorageByBalance(
  body: API.StoragePayCreateDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayStatusVO | null>>(
    '/web/order/pay/storage/balance',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 算法推送费用预估 POST /web/my-algorithm/push-fee-preview */
export async function previewAlgorithmPushFee(
  body: API.PushFeePreviewDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PushFeePreviewVO>>(
    '/web/my-algorithm/push-fee-preview',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 钱包摘要 GET /web/cloud/wallet/summary */
export async function getCloudWalletSummary(options?: {
  [key: string]: any;
}) {
  return request<API.ApiResponse<API.WalletSummaryVO>>(
    '/web/cloud/wallet/summary',
    { method: 'GET', ...(options || {}) },
  );
}

/** 余额充值二维码 POST /web/cloud/wallet/recharge/qr */
export async function createWalletRechargeQr(
  body: API.WalletRechargeQrDTO,
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PayQrVO>>(
    '/web/cloud/wallet/recharge/qr',
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: body,
      ...(options || {}),
    },
  );
}

/** 钱包流水 GET /web/cloud/wallet/ledger */
export async function getCloudWalletLedger(
  params?: { current?: number; size?: number },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.WalletLedgerItemVO[]>>(
    '/web/cloud/wallet/ledger',
    { method: 'GET', params, ...(options || {}) },
  );
}

/** 日结算账单 GET /web/cloud/daily-bill/list */
export async function listCloudDailyBills(
  params: { month: string },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.DailyBillItemVO[]>>(
    '/web/cloud/daily-bill/list',
    { method: 'GET', params, ...(options || {}) },
  );
}

/** 计费订单记录 GET /web/cloud/billing/orders */
export async function listCloudBillingOrders(
  params?: { current?: number; size?: number },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.BillingOrderItemVO[]>>(
    '/web/cloud/billing/orders',
    { method: 'GET', params, ...(options || {}) },
  );
}

/** 充值记录 GET /web/cloud/wallet/recharges */
export async function listCloudWalletRecharges(
  params?: { current?: number; size?: number },
  options?: { [key: string]: any },
) {
  return request<API.ApiResponse<API.PageResultVO<API.WalletRechargeItemVO>>>(
    '/web/cloud/wallet/recharges',
    { method: 'GET', params, ...(options || {}) },
  );
}
